import React, { useState } from "react";
import { Link } from "react-router-dom";

import bg1 from '../assets/images/bg/contactus-1.png'
import Navbar from "../components/navbar";
import { contact } from "../data/data";
import Footer from "../components/footer";
import ScrollTop from "../components/scrollTop";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", comments: "" });
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(null);

    function validate() {
        const errs = {};
        if (!form.name.trim()) errs.name = "Name is required";
        if (!form.email.trim()) errs.email = "Email is required";
        else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email)) errs.email = "Invalid email";
        if (!form.phone.trim()) errs.phone = "Phone is required";
        else if (!/^[0-9]{10,15}$/.test(form.phone)) errs.phone = "Invalid phone number";
        if (!form.comments.trim()) errs.comments = "Message is required";
        return errs;
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const errs = validate();
        if (Object.keys(errs).length) {
            setErrors(errs);
            return;
        }
        setSubmitting(true);
        setErrors({});
        setSuccess(null);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/contact`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form)
            });
            if (res.ok) {
                setSuccess("Your message has been sent! We will get back to you soon.");
                setForm({ name: "", email: "", phone: "", subject: "", comments: "" });
            } else {
                setSuccess("Something went wrong. Please try again.");
            }
        } catch {
            setSuccess("Something went wrong. Please try again.");
        }
        setSubmitting(false);
    }

    return (
        <>
            <Navbar manuClass="navigation-menu nav-left nav-light" containerClass="container" />
            <section
                className="bg-half contact-hero d-table w-100 position-relative"
                style={{ backgroundImage: `url(${bg1})` }}>
                {/* <div className="bg-overlay bg-overlay-dark"></div> */}
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            {/* <div className="section-title text-center">
                                <h3 className="sub-title mb-4 text-white title-dark">Contact Us</h3>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className="position-relative">
                <div className="shape overflow-hidden text-color-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div> */}

            <section className="contact-tiles-section">
                <div className="container">
                    <div className="row">
                        {contact.map((item, index) => {
                            let Icon = item.icon
                            // use anchor for external links (tel:, mailto:, http(s):) so they work correctly
                            const isExternal = /^(https?:|mailto:|tel:)/.test(item.link);
                            return (
                                <div className="col-lg-4 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0" key={index}>
                                    <div className="card features feature-primary text-center border-0">
                                        <div className="icon text-center rounded-md mx-auto">
                                            <Icon className="h3 mb-0" />
                                        </div>
                                        <div className="card-body p-0 mt-3">
                                            <h5>{item.title}</h5>
                                            {/* <p className="text-muted mt-3">{item.desc}</p> */}
                                            {isExternal ? (
                                                <a href={item.link} className="link" target={item.link.startsWith('http') ? '_blank' : undefined} rel={item.link.startsWith('http') ? 'noopener noreferrer' : undefined}>{item.name}</a>
                                            ) : (
                                                <Link to={item.link} className="link">{item.name}</Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className="container mt-100 mt-60">
                    <div className="row align-items-center">
                        <div className="col-lg-12 col-md-12 mt-4 pt-2 mt-sm-0 pt-sm-0">
                            <div className="custom-form rounded shadow p-4">
                                <h5 className="mb-4">Get in touch!</h5>
                                <form onSubmit={handleSubmit} noValidate>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Your Name <span className="text-danger">*</span></label>
                                                <input
                                                    name="name"
                                                    id="name"
                                                    type="text"
                                                    className={`form-control border rounded ${errors.name ? "is-invalid" : ""}`}
                                                    placeholder="First Name :"
                                                    value={form.name}
                                                    onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                                                />
                                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                                <input
                                                    name="email"
                                                    id="email"
                                                    type="email"
                                                    className={`form-control border rounded ${errors.email ? "is-invalid" : ""}`}
                                                    placeholder="Your email :"
                                                    value={form.email}
                                                    onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                                                />
                                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Phone <span className="text-danger">*</span></label>
                                                <input
                                                    name="phone"
                                                    id="phone"
                                                    type="tel"
                                                    className={`form-control border rounded ${errors.phone ? "is-invalid" : ""}`}
                                                    placeholder="Your phone number :"
                                                    value={form.phone}
                                                    onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
                                                />
                                                {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Subject</label>
                                                <input
                                                    name="subject"
                                                    id="subject"
                                                    className="form-control border rounded"
                                                    placeholder="Your subject :"
                                                    value={form.subject}
                                                    onChange={e => setForm(f => ({ ...f, subject: e.target.value }))}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label">Comments <span className="text-danger">*</span></label>
                                                <textarea
                                                    name="comments"
                                                    id="comments"
                                                    rows="4"
                                                    className={`form-control border rounded ${errors.comments ? "is-invalid" : ""}`}
                                                    placeholder="Your Message :"
                                                    value={form.comments}
                                                    onChange={e => setForm(f => ({ ...f, comments: e.target.value }))}
                                                ></textarea>
                                                {errors.comments && <div className="invalid-feedback">{errors.comments}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <button type="submit" id="submit" name="send" className="btn btn-primary" disabled={submitting}>
                                                {submitting ? "Sending..." : "Send Message"}
                                            </button>
                                            {success && (
                                                <div className={`alert mt-3 ${success.startsWith("Your message") ? "alert-success" : "alert-danger"}`}>
                                                    {success}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="container-fluid mt-100 mt-60">
                    <div className="row">
                        <div className="col-12 p-0">
                            <div className="card map border-0">
                                <div className="card-body p-0">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" style={{ border: '0' }} title="myfram" allowFullScreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </section>
            <Footer />
            <ScrollTop />
        </>
    )
}